import { render, staticRenderFns } from "./buyerinvoices.vue?vue&type=template&id=c482d4c0"
import script from "./buyerinvoices.vue?vue&type=script&lang=js"
export * from "./buyerinvoices.vue?vue&type=script&lang=js"
import style0 from "./buyerinvoices.vue?vue&type=style&index=0&id=c482d4c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports